export default __webpack_public_path__ + "static/media/close.447392de.svg";